import { render, staticRenderFns } from "./AegCasePersonalJewellery.vue?vue&type=template&id=035d0f5c"
import script from "./AegCasePersonalJewellery.vue?vue&type=script&lang=js"
export * from "./AegCasePersonalJewellery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports